export default [
  {
    path: '/scale',
    name: 'scale',
    component: () => import('./Scale.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'Scale',
    },
  },
]
